import { ModelPortfolioTypes } from '@generated/graphql';
import {
  isClientGroup,
  isGoal,
  isSubAccount,
  type PortfolioReport,
} from '@interfaces/portfolioReport';

const buildClientGoalPath = (clientId: string, goalId: string): string =>
  `/clients/${clientId}/goal/${goalId}`;

const buildClientGoalSubAccountPath = (
  clientId: string,
  goalId: string,
  subAccountSegmentId: string,
): string =>
  `/clients/${clientId}/goal/${goalId}/subaccount/${subAccountSegmentId}`;

export const getPortfolioReportPagePath = (
  report: PortfolioReport,
): string | null => {
  const { modelPortfolioType, object } = report;

  if (
    modelPortfolioType === ModelPortfolioTypes.Household &&
    isClientGroup(object)
  ) {
    return `/households/${object.id}`;
  }

  if (modelPortfolioType === ModelPortfolioTypes.Goal && isGoal(object)) {
    if (object.householdClientGroup?.id) {
      return `/households/${object.householdClientGroup.id}`;
    }

    const userId = object.user?.id;
    if (userId && object.id) {
      return buildClientGoalPath(userId, object.id);
    }

    return null;
  }

  if (
    modelPortfolioType === ModelPortfolioTypes.SubAccount &&
    isSubAccount(object)
  ) {
    const clientId = object.account?.user?.id;
    const goalId = object.goal?.id;
    const subAccountId = object.id;

    if (clientId && goalId && subAccountId) {
      return buildClientGoalSubAccountPath(clientId, goalId, subAccountId);
    }

    return null;
  }

  if (isClientGroup(object)) {
    return `/households/${object.id}`;
  }

  if (isGoal(object)) {
    if (object.householdClientGroup?.id) {
      return `/households/${object.householdClientGroup.id}`;
    }

    const userId = object.user?.id;
    if (userId && object.id) {
      return buildClientGoalPath(userId, object.id);
    }

    return null;
  }

  if (isSubAccount(object)) {
    const clientId = object.account?.user?.id;
    const goalId = object.goal?.id;
    const subAccountId = object.id;

    if (clientId && goalId && subAccountId) {
      return buildClientGoalSubAccountPath(clientId, goalId, subAccountId);
    }

    return null;
  }

  return null;
};

export const resolvePortfolioReportPagePath = (
  report: PortfolioReport | undefined,
): string | null => (report ? getPortfolioReportPagePath(report) : null);
